import React from 'react';
import { Home, User, TrendingUp } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import WebApp from '@twa-dev/sdk';
import { useTranslation } from 'react-i18next';
import { cn } from '../lib/utils';

export const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleNavigation = (path: string) => {
    WebApp.HapticFeedback.impactOccurred('light');
    navigate(path);
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="flex items-center justify-around w-full h-14 border-t border-black/5 bg-tg-bg select-none shadow-[0_-2px_8px_rgba(0,0,0,0.03)] supports-[backdrop-filter]:bg-tg-bg/70 supports-[backdrop-filter]:backdrop-blur-2xl supports-[backdrop-filter]:[-webkit-backdrop-filter:blur(24px)]">
      <div 
        className={cn(
          'flex flex-col items-center justify-center flex-1 h-full text-tg-hint transition-all duration-200 gap-1 pt-[18px] px-1 pb-1',
          isActive('/') && 'text-[#FF6B00] scale-105'
        )}
        onClick={() => handleNavigation('/')}
      >
        <Home 
          size={26} 
          strokeWidth={1.5} 
          className={cn(
            'text-tg-hint transition-all duration-200 min-w-[26px] min-h-[26px]',
            isActive('/') && 'text-[#FF6B00] drop-shadow-[0_2px_4px_rgba(255,107,0,0.2)]'
          )} 
        />
        <span className={cn(
          'text-xs leading-[14px] font-medium',
          isActive('/') && 'bg-gradient-to-r from-[#FF6B00] to-[#FF9F00] bg-clip-text text-transparent font-semibold'
        )}>
          {t('NAVIGATION.HOME')}
        </span>
      </div>
      <div 
        className={cn(
          'flex flex-col items-center justify-center flex-1 h-full text-tg-hint transition-all duration-200 gap-1 pt-[18px] px-1 pb-1',
          isActive('/portfolio-strategy') && 'text-[#FF6B00] scale-105'
        )}
        onClick={() => handleNavigation('/portfolio-strategy')}
      >
        <TrendingUp 
          size={26} 
          strokeWidth={1.5} 
          className={cn(
            'text-tg-hint transition-all duration-200 min-w-[26px] min-h-[26px]',
            isActive('/portfolio-strategy') && 'text-[#FF6B00] drop-shadow-[0_2px_4px_rgba(255,107,0,0.2)]'
          )} 
        />
        <span className={cn(
          'text-xs leading-[14px] font-medium',
          isActive('/portfolio-strategy') && 'bg-gradient-to-r from-[#FF6B00] to-[#FF9F00] bg-clip-text text-transparent font-semibold'
        )}>
          {t('NAVIGATION.PORTFOLIO')}
        </span>
      </div>
      <div 
        className={cn(
          'flex flex-col items-center justify-center flex-1 h-full text-tg-hint transition-all duration-200 gap-1 pt-[18px] px-1 pb-1',
          isActive('/profile') && 'text-[#FF6B00] scale-105'
        )}
        onClick={() => handleNavigation('/profile')}
      >
        <User 
          size={26} 
          strokeWidth={1.5} 
          className={cn(
            'text-tg-hint transition-all duration-200 min-w-[26px] min-h-[26px]',
            isActive('/profile') && 'text-[#FF6B00] drop-shadow-[0_2px_4px_rgba(255,107,0,0.2)]'
          )} 
        />
        <span className={cn(
          'text-xs leading-[14px] font-medium',
          isActive('/profile') && 'bg-gradient-to-r from-[#FF6B00] to-[#FF9F00] bg-clip-text text-transparent font-semibold'
        )}>
          {t('NAVIGATION.PROFILE')}
        </span>
      </div>
    </nav>
  );
}; 